/* ============================================================
   Success Stories — testimonial carousel (Swiper 11, bundled)
   ------------------------------------------------------------
   Same Swiper import style as the other home carousels. One
   testimonial per view; each slide's prev/next buttons
   ([data-t-prev]/[data-t-next]) drive the single instance.
   Uses a fade transition instead of the default slide/translate.
   ============================================================ */
import Swiper from "swiper";
import {
  Navigation,
  EffectFade,
  Autoplay,
  Mousewheel,
  Keyboard,
} from "swiper/modules";
import "swiper/css/effect-fade";

export function initTestimonials() {
  var el = document.querySelector(".testimonials-swiper");
  if (!el) return;

  var swiper = new Swiper(el, {
    modules: [Navigation, EffectFade, Autoplay, Mousewheel, Keyboard],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 500,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    autoHeight: window.innerWidth <= 767,

    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
  });

  document.querySelectorAll("[data-t-prev]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      swiper.slidePrev();
    });
  });

  document.querySelectorAll("[data-t-next]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      swiper.slideNext();
    });
  });

  // Apply adaptive height when viewport reaches 767px
  window.addEventListener("resize", function () {
    var isMobile = window.innerWidth <= 767;

    if (swiper.params.autoHeight !== isMobile) {
      swiper.params.autoHeight = isMobile;

      swiper.update();

      if (isMobile) {
        swiper.updateAutoHeight(300);
      }
    }
  });
}
